/*
** OpenAPI Client - CONFIGURATION
*/
export var OpenAPI;
(function (OpenAPI) {
    OpenAPI.URL = '';
})(OpenAPI || (OpenAPI = {}));
//# sourceMappingURL=index.js.map